import { EquipmentCategory } from "@/types";

export const equipmentCategoriesData: EquipmentCategory[] = [
  {
    "id": "closed-circuit-rebreather-ccr-diving-set",
    "slug": "closed-circuit-rebreather-ccr-diving-set",
    "title": "Closed Circuit Rebreather (CCR) Diving Set",
    "shortTitle": "Closed Circuit Rebreather (CCR) Diving Set",
    "description": "Engineered tactical and commercial equipment for Closed Circuit Rebreather (CCR) Diving Set.",
    "image": "/images/capabilities/equipments/Closed Circuit Rebreathers.png",
    "items": [
      {
        "id": "revo-closed-circuit-rebreather",
        "type": "pdf",
        "title": "reVo Closed Circuit Rebreather",
        "image": "/images/capabilities/previews/revo-closed-circuit-rebreather.png",
        "pdfUrl": "https://drive.google.com/file/d/1p7VrUFobx-etCnyV0zDF-xF4R_KpCLAe/view?usp=drive_link",
        "fileSize": "2.5 MB"
      },
      {
        "id": "revo-military-rebreather",
        "type": "pdf",
        "title": "rEvo Military Rebreather",
        "image": "/images/capabilities/previews/revo-military-rebreather.png",
        "pdfUrl": "https://drive.google.com/file/d/1swlE2s3aXM0USW00Xs4UFQO626fz-Wgv/view?usp=drive_link",
        "fileSize": "3.7 MB"
      },
      {
        "id": "soda-lime-co2-absorbent-divelime-812",
        "type": "pdf",
        "title": "Soda Lime CO2 Absorbent Divelime 812",
        "image": "/images/capabilities/previews/soda-lime-co2-absorbent-divelime-812.png",
        "pdfUrl": "https://drive.google.com/file/d/1XMDAjtlIiHGHf3EKYZVBWnIuESHrqAXi/view?usp=drive_link",
        "fileSize": "0.6 MB"
      }
    ]
  },
  {
    "id": "communication-system",
    "slug": "communication-system",
    "title": "Communication System",
    "shortTitle": "Communication System",
    "description": "Engineered tactical and commercial equipment for Communication System.",
    "image": "/images/capabilities/equipments/Communication System.png",
    "items": [
      {
        "id": "direct-underwater-communication-system-ducs",
        "slug": "direct-underwater-communication-system-ducs",
        "type": "folder",
        "title": "Direct Underwater Communication System (DUCS)",
        "image": "/images/capabilities/direct-underwater/Oceanreef Underwater Communication Mask.png",
        "items": [
          {
            "id": "oceanreef-gamma-alpha-hd-audio-video-surface-unit",
            "type": "pdf",
            "title": "OCEANREEF Gamma Alpha HD Audio & Video Surface Unit",
            "image": "/images/capabilities/previews/oceanreef-gamma-alpha-hd-audio-video-surface-unit.png",
            "pdfUrl": "https://drive.google.com/file/d/14zLygF57-wwIJsOelVFcLmoJntZsfB7T/view?usp=drive_link",
            "fileSize": "0.4 MB"
          },
          {
            "id": "oceanreef-alpha-pro-x-hardwired-communication-system",
            "type": "pdf",
            "title": "OCEANREEF Alpha Pro X Hardwired Communication System",
            "image": "/images/capabilities/previews/oceanreef-alpha-pro-x-hardwired-communication-system.png",
            "pdfUrl": "https://drive.google.com/file/d/1uXWOI9cx_ENdVE1oGOVBCNr2Bf8gnvb4/view?usp=drive_link",
            "fileSize": "0.8 MB"
          }
        ]
      },
      {
        "id": "wireless-underwater-communication-system-wucs",
        "slug": "wireless-underwater-communication-system-wucs",
        "type": "folder",
        "title": "Wireless Underwater Communication System (WUCS)",
        "image": "/images/capabilities/direct-underwater/OceanReef Wireless Underwater Communication System.png",
        "items": [
          {
            "id": "oceanreef-wireless-communication-system-wucs-audio-only",
            "type": "pdf",
            "title": "OCEANREEF Wireless Communication System (WUCS) Audio Only",
            "image": "/images/capabilities/previews/oceanreef-wireless-communication-system-wucs-audio-only.png",
            "pdfUrl": "https://drive.google.com/file/d/1cIuwbHbP8J1G-qpHDap7yY0OyB8Ymupm/view?usp=drive_link",
            "fileSize": "1.5 MB"
          }
        ]
      }
    ]
  },
  {
    "id": "compressor",
    "slug": "compressor",
    "title": "Compressor",
    "shortTitle": "Compressor",
    "description": "Engineered tactical and commercial equipment for Compressor.",
    "image": "/images/capabilities/equipments/Compressor.png",
    "items": [
      {
        "id": "coltri-icon-100-petrol",
        "type": "pdf",
        "title": "Coltri ICON 100 Petrol",
        "image": "/images/capabilities/previews/coltri-icon-100-petrol.png",
        "pdfUrl": "https://drive.google.com/file/d/1RbNaCT5wQu8srjcNq-3Ptg1-zzclb0p9/view?usp=drive_link",
        "fileSize": "1.0 MB"
      },
      {
        "id": "coltri-mch-16-et-ergo",
        "type": "pdf",
        "title": "Coltri MCH 16 ET ERGO",
        "image": "/images/capabilities/previews/coltri-mch-16-et-ergo.png",
        "pdfUrl": "https://drive.google.com/file/d/179ss8AoQHXtVwxhcK8QnsIuI-mQkjgcC/view?usp=drive_link",
        "fileSize": "0.7 MB"
      },
      {
        "id": "coltri-predator",
        "type": "pdf",
        "title": "Coltri PREDATOR",
        "image": "/images/capabilities/previews/coltri-predator.png",
        "pdfUrl": "https://drive.google.com/file/d/103W8YiYKids0oLCc6pgN25_QkLBjmx5T/view?usp=drive_link",
        "fileSize": "0.7 MB"
      }
    ]
  },
  {
    "id": "dive-computer",
    "slug": "dive-computer",
    "title": "Dive Computer",
    "shortTitle": "Dive Computer",
    "description": "Engineered tactical and commercial equipment for Dive Computer.",
    "image": "/images/capabilities/equipments/Dive Computer.png",
    "items": [
      {
        "id": "aqualung-dive-computers",
        "type": "pdf",
        "title": "Aqualung Dive Computers",
        "image": "/images/capabilities/previews/aqualung-dive-computers.png",
        "pdfUrl": "https://drive.google.com/file/d/10gKACD4yCE9BsoHuUHz3HqhrDTnIWq9t/view?usp=drive_link",
        "fileSize": "3.7 MB"
      },
      {
        "id": "mares-dive-computers",
        "type": "pdf",
        "title": "Mares Dive Computers",
        "image": "/images/capabilities/previews/mares-dive-computers.png",
        "pdfUrl": "https://drive.google.com/file/d/1DwGi0yWYYt6-7fPd3j-OzM89Mt7g88Uw/view?usp=drive_link",
        "fileSize": "2.0 MB"
      },
      {
        "id": "shearwater-dive-computer-accessories",
        "type": "pdf",
        "title": "Shearwater Dive Computer + Accessories",
        "image": "/images/capabilities/previews/shearwater-dive-computer-accessories.png",
        "pdfUrl": "https://drive.google.com/file/d/16dA83OlGkCd053jaRd6gi6K9bqCcB4mj/view?usp=drive_link",
        "fileSize": "7.8 MB"
      },
      {
        "id": "tusa-dive-computers",
        "type": "pdf",
        "title": "TUSA Dive Computers",
        "image": "/images/capabilities/previews/tusa-dive-computers.png",
        "pdfUrl": "https://drive.google.com/file/d/1Bp05T9u_pBR2VVgIspLnlwt4WmuF2_dN/view?usp=drive_link",
        "fileSize": "2.3 MB"
      }
    ]
  },
  {
    "id": "diver-locater-system",
    "slug": "diver-locater-system",
    "title": "Diver Locater System",
    "shortTitle": "Diver Locater System",
    "description": "Engineered tactical and commercial equipment for Diver Locater System.",
    "image": "/images/capabilities/equipments/Diver Locater System.png",
    "items": [
      {
        "id": "surface-locator",
        "slug": "surface-locator",
        "type": "folder",
        "title": "Surface Locator",
        "image": "/images/capabilities/diver-locator-system/Surface Locater.png",
        "items": [
          {
            "id": "seareq-enos-mobos-pro",
            "type": "pdf",
            "title": "Seareq ENOS + MOBOS Pro",
            "image": "/images/capabilities/previews/seareq-enos-mobos-pro.png",
            "pdfUrl": "https://drive.google.com/file/d/1uvhmNlxDYuU8KehICqtvdbCRWfiFW8I7/view?usp=drive_link",
            "fileSize": "1.9 MB"
          }
        ]
      },
      {
        "id": "underwater-locator",
        "slug": "underwater-locator",
        "type": "folder",
        "title": "Underwater Locator",
        "image": "/images/capabilities/diver-locator-system/Underwater Locater.png",
        "items": [
          {
            "id": "diver-tracker-sonardyne-brochure",
            "type": "pdf",
            "title": "Diver Tracker Sonardyne Brochure",
            "image": "/images/capabilities/previews/diver-tracker-sonardyne-brochure.png",
            "pdfUrl": "https://drive.google.com/file/d/1MeZGiWOYcAOVfogmK_OI7DdzEcXRFsdX/view?usp=drive_link",
            "fileSize": "3.2 MB"
          }
        ]
      }
    ]
  },
  {
    "id": "diving-accessories",
    "slug": "diving-accessories",
    "title": "Diving Accessories",
    "shortTitle": "Diving Accessories",
    "description": "Engineered tactical and commercial equipment for Diving Accessories.",
    "image": "/images/capabilities/equipments/Diving Accessories.png",
    "items": [
      {
        "id": "apeks-torches-bags-reels-spools",
        "type": "pdf",
        "title": "APEKS Torches, Bags, Reels & Spools",
        "image": "/images/capabilities/previews/apeks-torches-bags-reels-spools.png",
        "pdfUrl": "https://drive.google.com/file/d/1xUbS_jB-VhYZoRaXiBEtrfnWdKAINZug/view?usp=drive_link",
        "fileSize": "17.1 MB"
      },
      {
        "id": "apeks-torches",
        "type": "pdf",
        "title": "APEKS Torches",
        "image": "/images/capabilities/previews/apeks-torches.png",
        "pdfUrl": "https://drive.google.com/file/d/1UAwJDeCLVD-gCR4B4hFzYMZc-lNBKhZe/view?usp=drive_link",
        "fileSize": "6.2 MB"
      },
      {
        "id": "aqualung-bags-knives-accessories",
        "type": "pdf",
        "title": "Aqualung Bags, Knives & Accessories",
        "image": "/images/capabilities/previews/aqualung-bags-knives-accessories.png",
        "pdfUrl": "https://drive.google.com/file/d/1Q8JsJYW5dc07JlA-xTdg8dQURPzgIeY6/view?usp=drive_link",
        "fileSize": "15.5 MB"
      },
      {
        "id": "aropec-accessories",
        "type": "pdf",
        "title": "Aropec Accessories",
        "image": "/images/capabilities/previews/aropec-accessories.png",
        "pdfUrl": "https://drive.google.com/file/d/1d-r4djvXq0TNYP7gPQxXbfHKqWnJ8tcz/view?usp=drive_link",
        "fileSize": "6.5 MB"
      },
      {
        "id": "mares-accessories-xr",
        "type": "pdf",
        "title": "Mares Accessories XR",
        "image": "/images/capabilities/previews/mares-accessories-xr.png",
        "pdfUrl": "https://drive.google.com/file/d/1OGQDMikOhuyVOCMJxSBnT7tmsxOaJ3G6/view?usp=drive_link",
        "fileSize": "3.1 MB"
      },
      {
        "id": "mares-accessories",
        "type": "pdf",
        "title": "Mares Accessories",
        "image": "/images/capabilities/previews/mares-accessories.png",
        "pdfUrl": "https://drive.google.com/file/d/11KiE0q37ysPjWrOkomuMkfT-y-ICBpTK/view?usp=drive_link",
        "fileSize": "6.2 MB"
      },
      {
        "id": "orcatorch-torch-accessories",
        "type": "pdf",
        "title": "OrcaTorch Torch & Accessories",
        "image": "/images/capabilities/previews/orcatorch-torch-accessories.png",
        "pdfUrl": "https://drive.google.com/file/d/1hRTTCKvltT-lBPTLJonXvasADAyh4oKE/view?usp=drive_link",
        "fileSize": "7.9 MB"
      },
      {
        "id": "tusa-accessories",
        "type": "pdf",
        "title": "TUSA Accessories",
        "image": "/images/capabilities/previews/tusa-accessories.png",
        "pdfUrl": "https://drive.google.com/file/d/1BJDZNZJLZ4J9M8qlxuP0wWHdoPdz0Yfi/view?usp=drive_link",
        "fileSize": "6.6 MB"
      }
    ]
  },
  {
    "id": "dpv-accessories",
    "slug": "dpv-accessories",
    "title": "Diver Propulsion Vehicle",
    "shortTitle": "Diver Propulsion Vehicle",
    "description": "Engineered tactical and commercial equipment for Diver Propulsion Vehicle",
    "image": "/images/capabilities/equipments/DPV Accessories.jpg",
    "items": [
      {
        "id": "seacraft-dry-bags-with-buoyancy-system",
        "type": "pdf",
        "title": "SEACRAFT Dry Bags with Buoyancy System",
        "image": "/images/capabilities/previews/seacraft-dry-bags-with-buoyancy-system.png",
        "pdfUrl": "https://drive.google.com/file/d/1kOQhtC1V6XtrXvBBiBXL-Qk6Nnj3Obtn/view?usp=drive_link",
        "fileSize": "2.1 MB"
      },
      {
        "id": "seacraft-enc3m-platform",
        "type": "pdf",
        "title": "SEACRAFT ENC3M Platform",
        "image": "/images/capabilities/previews/seacraft-enc3m-platform.png",
        "pdfUrl": "https://drive.google.com/file/d/1JaE1TXCgVVCJkXe_cG5-7icMWHUECzNe/view?usp=drive_link",
        "fileSize": "2.2 MB"
      },
      {
        "id": "seacraft-gps-rf-buoy",
        "type": "pdf",
        "title": "SEACRAFT GPS RF Buoy",
        "image": "/images/capabilities/previews/seacraft-gps-rf-buoy.png",
        "pdfUrl": "https://drive.google.com/file/d/1yHqgZ1RQPviH4XY94HERkmm3KRVcEXBc/view?usp=drive_link",
        "fileSize": "0.7 MB"
      },
      {
        "id": "seacraft-india-catalogue-military-edition",
        "type": "pdf",
        "title": "SEACRAFT INDIA Catalogue Military Edition",
        "image": "/images/capabilities/previews/seacraft-india-catalogue-military-edition.png",
        "pdfUrl": "https://drive.google.com/file/d/1InKZXT_NXo0G-SZKSLVW9NIEXagl7xpg/view?usp=drive_link",
        "fileSize": "9.8 MB"
      },
      {
        "id": "seacraft-special-dpc-leaflet",
        "type": "pdf",
        "title": "SEACRAFT SPECIAL DPC LEAFLET",
        "image": "/images/capabilities/previews/seacraft-special-dpc-leaflet.png",
        "pdfUrl": "https://drive.google.com/file/d/1Hp1R1ch5C845h84p3cVhLYqOs0GUuyp6/view?usp=drive_link",
        "fileSize": "2.5 MB"
      },
      {
        "id": "seacraft-special-products-card",
        "type": "pdf",
        "title": "SEACRAFT Special Products Card",
        "image": "/images/capabilities/previews/seacraft-special-products-card.png",
        "pdfUrl": "https://drive.google.com/file/d/1BhQYsGVi8kjiLsoaN64q2hg459u7xUt6/view?usp=drive_link",
        "fileSize": "78.0 MB"
      }
    ]
  },
  {
    "id": "dry-suits",
    "slug": "dry-suits",
    "title": "Dry Suits",
    "shortTitle": "Dry Suits",
    "description": "Engineered tactical and commercial equipment for Dry Suits.",
    "image": "/images/capabilities/equipments/Dry Suits.png",
    "items": [
      {
        "id": "apeks-dry-suit-accessories",
        "type": "pdf",
        "title": "APEKS Dry Suit & Accessories",
        "image": "/images/capabilities/previews/apeks-dry-suit-accessories.png",
        "pdfUrl": "https://drive.google.com/file/d/1zhqRwo75z1rQ7NlS3IsCDG7SIQ-KjifS/view?usp=drive_link",
        "fileSize": "2.6 MB"
      },
      {
        "id": "aqualung-drywear-accessories",
        "type": "pdf",
        "title": "Aqualung Drywear & Accessories",
        "image": "/images/capabilities/previews/aqualung-drywear-accessories.png",
        "pdfUrl": "https://drive.google.com/file/d/1gtzYLMQYvieuupF8ijdvJfmu_A5K-LEL/view?usp=drive_link",
        "fileSize": "3.9 MB"
      },
      {
        "id": "bare-drysuit-base-layer-accessories",
        "type": "pdf",
        "title": "BARE Drysuit, Base Layer & Accessories",
        "image": "/images/capabilities/previews/bare-drysuit-base-layer-accessories.png",
        "pdfUrl": "https://drive.google.com/file/d/1RXq4XHLqNybC6qaINsAYCQs65MFoQn-6/view?usp=drive_link",
        "fileSize": "30.6 MB"
      },
      {
        "id": "mares-insulation",
        "type": "pdf",
        "title": "Mares Insulation",
        "image": "/images/capabilities/previews/mares-insulation.png",
        "pdfUrl": "https://drive.google.com/file/d/19N89FzRtuZY-taMYfD7_h42zRa6bn7bT/view?usp=drive_link",
        "fileSize": "2.0 MB"
      }
    ]
  },
  {
    "id": "full-face-mask-ffm",
    "slug": "full-face-mask-ffm",
    "title": "Full Face Mask (FFM)",
    "shortTitle": "Full Face Mask (FFM)",
    "description": "Engineered tactical and commercial equipment for Full Face Mask (FFM).",
    "image": "/images/capabilities/equipments/Full Face Masks.png",
    "items": [
      {
        "id": "oceanreef-full-face-mask-neptune-iii",
        "type": "pdf",
        "title": "OCEANREEF Full Face Mask Neptune III",
        "image": "/images/capabilities/previews/oceanreef-full-face-mask-neptune-iii.png",
        "pdfUrl": "https://drive.google.com/file/d/1njJmaDt1vQbumO5ZBYAuG09Xpgspc2Ib/view?usp=drive_link",
        "fileSize": "1.4 MB"
      },
      {
        "id": "oceanreef-ffm-accessories",
        "type": "pdf",
        "title": "OCEANREEF FFM Accessories",
        "image": "/images/capabilities/previews/oceanreef-ffm-accessories.png",
        "pdfUrl": "https://drive.google.com/file/d/1IVBPx5QlyeJuNGl6BfQsuVKcHZNuFhxe/view?usp=drive_link",
        "fileSize": "1.6 MB"
      },
      {
        "id": "oceanreef-full-face-mask-vesper",
        "type": "pdf",
        "title": "OCEANREEF Full Face Mask Vesper",
        "image": "/images/capabilities/previews/oceanreef-full-face-mask-vesper.png",
        "pdfUrl": "https://drive.google.com/file/d/1wURvR9c2eZheOr8MccIN01cz9FWcpKYv/view?usp=drive_link",
        "fileSize": "0.6 MB"
      }
    ]
  },
  {
    "id": "kayaks",
    "slug": "kayaks",
    "title": "Kayaks",
    "shortTitle": "Kayaks",
    "description": "Engineered tactical and commercial equipment for Kayaks.",
    "image": "/images/capabilities/equipments/Kayaks.png",
    "items": [
      {
        "id": "klepper-military-catalog",
        "type": "pdf",
        "title": "klepper military catalog",
        "image": "/images/capabilities/previews/klepper-military-catalog.png",
        "pdfUrl": "https://drive.google.com/file/d/18NeBejN4sjj3vUTNjY1xTptgZWj1vYHX/view?usp=drive_link",
        "fileSize": "2.2 MB"
      }
    ]
  },
  {
    "id": "open-circuit-scuba",
    "slug": "open-circuit-scuba",
    "title": "Open Circuit SCUBA",
    "shortTitle": "Open Circuit SCUBA",
    "description": "Engineered tactical and commercial equipment for Open Circuit SCUBA.",
    "image": "/images/capabilities/equipments/Open Circuit Scuba.png",
    "items": [
      {
        "id": "apex",
        "slug": "apex",
        "type": "folder",
        "title": "Apex",
        "image": "/images/capabilities/open-circuit-scuba/Apeks.png",
        "items": [
          {
            "id": "apeks-bcd",
            "type": "pdf",
            "title": "APEKS BCD",
            "image": "/images/capabilities/previews/apeks-bcd.png",
            "pdfUrl": "https://drive.google.com/file/d/136xXqlUuiTkoJB_6qLXXQ978y1ioAu5o/view?usp=drive_link",
            "fileSize": "10.5 MB"
          },
          {
            "id": "apeks-instruments",
            "type": "pdf",
            "title": "APEKS Instruments",
            "image": "/images/capabilities/previews/apeks-instruments.png",
            "pdfUrl": "https://drive.google.com/file/d/199EuIkw5xYXRTv7zt7RxVSEtZySCH3KP/view?usp=drive_link",
            "fileSize": "3.2 MB"
          },
          {
            "id": "apeks-mask-fins",
            "type": "pdf",
            "title": "APEKS Mask & Fins",
            "image": "/images/capabilities/previews/apeks-mask-fins.png",
            "pdfUrl": "https://drive.google.com/file/d/1J-_NIgBKcjv8sh2dCsrVkBR5o3SVULLW/view?usp=drive_link",
            "fileSize": "7.3 MB"
          },
          {
            "id": "apeks-regulators",
            "type": "pdf",
            "title": "APEKS Regulators",
            "image": "/images/capabilities/previews/apeks-regulators.png",
            "pdfUrl": "https://drive.google.com/file/d/1AFa3mvAFUVwod1g3hxDK2gCFIm6ZDZ6P/view?usp=drive_link",
            "fileSize": "16.8 MB"
          }
        ]
      },
      {
        "id": "aqualung",
        "slug": "aqualung",
        "type": "folder",
        "title": "Aqualung",
        "image": "/images/capabilities/open-circuit-scuba/Aqualung.png",
        "items": [
          {
            "id": "aqualung-bcd",
            "type": "pdf",
            "title": "Aqualung BCD",
            "image": "/images/capabilities/previews/aqualung-bcd.png",
            "pdfUrl": "https://drive.google.com/file/d/1vRGn9ST7Ge-U62PrQ7ajHEUA88BVn0H1/view?usp=drive_link",
            "fileSize": "10.5 MB"
          },
          {
            "id": "aqualung-fins",
            "type": "pdf",
            "title": "AquaLung Fins",
            "image": "/images/capabilities/previews/aqualung-fins.png",
            "pdfUrl": "https://drive.google.com/file/d/1H3cgTptMiN76U1iPGVBVex9DjSZQ8y5z/view?usp=drive_link",
            "fileSize": "6.0 MB"
          },
          {
            "id": "aqualung-instruments",
            "type": "pdf",
            "title": "Aqualung Instruments",
            "image": "/images/capabilities/previews/aqualung-instruments.png",
            "pdfUrl": "https://drive.google.com/file/d/1BWeX5kJ1rMeDKd3M980Sdxg1y3baOD9Q/view?usp=drive_link",
            "fileSize": "6.4 MB"
          },
          {
            "id": "aqualung-mask-snorkel",
            "type": "pdf",
            "title": "Aqualung Mask & Snorkel",
            "image": "/images/capabilities/previews/aqualung-mask-snorkel.png",
            "pdfUrl": "https://drive.google.com/file/d/1xKeIaOGPKdCNduw7h22EspZesLmUlm__/view?usp=drive_link",
            "fileSize": "12.2 MB"
          },
          {
            "id": "aqualung-regulators",
            "type": "pdf",
            "title": "Aqualung Regulators",
            "image": "/images/capabilities/previews/aqualung-regulators.png",
            "pdfUrl": "https://drive.google.com/file/d/10Cqdh16POIvh6zGVYRj1hG8ejFX6hrNw/view?usp=drive_link",
            "fileSize": "10.6 MB"
          }
        ]
      },
      {
        "id": "dive-computer",
        "slug": "dive-computer",
        "type": "folder",
        "title": "Dive Computer",
        "image": "/images/capabilities/open-circuit-scuba/Dive Computer.png",
        "items": [
          {
            "id": "aqualung-dive-computers",
            "type": "pdf",
            "title": "Aqualung Dive Computers",
            "image": "/images/capabilities/previews/aqualung-dive-computers.png",
            "pdfUrl": "https://drive.google.com/file/d/1isRmWdF5MHLD4_wySAb5GUdabvKQK9xz/view?usp=drive_link",
            "fileSize": "3.7 MB"
          },
          {
            "id": "mares-dive-computers",
            "type": "pdf",
            "title": "Mares Dive Computers",
            "image": "/images/capabilities/previews/mares-dive-computers.png",
            "pdfUrl": "https://drive.google.com/file/d/14ggNdnrPHM9n4P_G_7U5O_ddcWRPL5T_/view?usp=drive_link",
            "fileSize": "2.0 MB"
          },
          {
            "id": "shearwater-dive-computer-accessories",
            "type": "pdf",
            "title": "Shearwater Dive Computer + Accessories",
            "image": "/images/capabilities/previews/shearwater-dive-computer-accessories.png",
            "pdfUrl": "https://drive.google.com/file/d/1cKogpgPke3pKYKX8PeAZ-gg07fEPi6PG/view?usp=drive_link",
            "fileSize": "7.8 MB"
          },
          {
            "id": "tusa-dive-computers",
            "type": "pdf",
            "title": "TUSA Dive Computers",
            "image": "/images/capabilities/previews/tusa-dive-computers.png",
            "pdfUrl": "https://drive.google.com/file/d/1IVVzily2eB369fz01XZLyUmck3Ywk216/view?usp=drive_link",
            "fileSize": "2.3 MB"
          }
        ]
      },
      {
        "id": "mares",
        "slug": "mares",
        "type": "folder",
        "title": "Mares",
        "image": "/images/capabilities/open-circuit-scuba/Mares.png",
        "items": [
          {
            "id": "mares-bcd",
            "type": "pdf",
            "title": "Mares BCD",
            "image": "/images/capabilities/previews/mares-bcd.png",
            "pdfUrl": "https://drive.google.com/file/d/1NOGDXEaSLvyv3257DlGiwddcoiSSr5t_/view?usp=drive_link",
            "fileSize": "4.8 MB"
          },
          {
            "id": "mares-diving-centre",
            "type": "pdf",
            "title": "Mares Diving Centre",
            "image": "/images/capabilities/previews/mares-diving-centre.png",
            "pdfUrl": "https://drive.google.com/file/d/1hg5Neq5-mdN2meFSjArTiE4vsPB0_d1J/view?usp=drive_link",
            "fileSize": "3.3 MB"
          },
          {
            "id": "mares-fins",
            "type": "pdf",
            "title": "Mares Fins",
            "image": "/images/capabilities/previews/mares-fins.png",
            "pdfUrl": "https://drive.google.com/file/d/1pkE8gR8EfyysWv0In9h1nujQ2tBfoEXd/view?usp=drive_link",
            "fileSize": "3.7 MB"
          },
          {
            "id": "mares-gauges",
            "type": "pdf",
            "title": "Mares Gauges",
            "image": "/images/capabilities/previews/mares-gauges.png",
            "pdfUrl": "https://drive.google.com/file/d/1aMd2jOBMDRSoNhu2zyU5eJzX6rmpMskL/view?usp=drive_link",
            "fileSize": "2.6 MB"
          },
          {
            "id": "mares-insulation",
            "type": "pdf",
            "title": "Mares Insulation",
            "image": "/images/capabilities/previews/mares-insulation.png",
            "pdfUrl": "https://drive.google.com/file/d/1ytUvcw_UnEg0EYOjB7Kct0xV88m9Syzi/view?usp=drive_link",
            "fileSize": "2.0 MB"
          },
          {
            "id": "mares-mask-snorkel",
            "type": "pdf",
            "title": "Mares Mask & Snorkel",
            "image": "/images/capabilities/previews/mares-mask-snorkel.png",
            "pdfUrl": "https://drive.google.com/file/d/1HFzrG9tvaAzmvvNhvlc_pND6M1g3hKK4/view?usp=drive_link",
            "fileSize": "3.6 MB"
          },
          {
            "id": "mares-regulator",
            "type": "pdf",
            "title": "Mares Regulator",
            "image": "/images/capabilities/previews/mares-regulator.png",
            "pdfUrl": "https://drive.google.com/file/d/1mPacZkIelng-jduh9r9IW8WhJBa_7ja5/view?usp=drive_link",
            "fileSize": "3.4 MB"
          }
        ]
      },
      {
        "id": "tusa",
        "slug": "tusa",
        "type": "folder",
        "title": "Tusa",
        "image": "/images/capabilities/open-circuit-scuba/OCS Tusa.png",
        "items": [
          {
            "id": "tusa-bcd",
            "type": "pdf",
            "title": "TUSA BCD",
            "image": "/images/capabilities/previews/tusa-bcd.png",
            "pdfUrl": "https://drive.google.com/file/d/1yoC3yiMbrsw1GPM-uJuPdIkhaCuCmpZ6/view?usp=drive_link",
            "fileSize": "9.5 MB"
          },
          {
            "id": "tusa-fins",
            "type": "pdf",
            "title": "TUSA Fins",
            "image": "/images/capabilities/previews/tusa-fins.png",
            "pdfUrl": "https://drive.google.com/file/d/1aXZc_pKpDGkHC9sYtUvgxKkqjqmzsHus/view?usp=drive_link",
            "fileSize": "19.5 MB"
          },
          {
            "id": "tusa-guages",
            "type": "pdf",
            "title": "TUSA Guages",
            "image": "/images/capabilities/previews/tusa-guages.png",
            "pdfUrl": "https://drive.google.com/file/d/1tL8s4KS7CsHHIOUaXCuM8y4GpxyvG1D8/view?usp=drive_link",
            "fileSize": "5.3 MB"
          },
          {
            "id": "tusa-mask-snorkel",
            "type": "pdf",
            "title": "TUSA Mask & Snorkel",
            "image": "/images/capabilities/previews/tusa-mask-snorkel.png",
            "pdfUrl": "https://drive.google.com/file/d/13B7Chka_x3dSTY3-LT5mSpa7kO-rYVmJ/view?usp=drive_link",
            "fileSize": "20.8 MB"
          },
          {
            "id": "tusa-regulator",
            "type": "pdf",
            "title": "TUSA Regulator",
            "image": "/images/capabilities/previews/tusa-regulator.png",
            "pdfUrl": "https://drive.google.com/file/d/1KcyDVcmNaZFSmo-jmcEPe0DK-OTavcOf/view?usp=drive_link",
            "fileSize": "5.0 MB"
          }
        ]
      }
    ]
  },
  {
    "id": "out-board-motor-obm-s",
    "slug": "out-board-motor-obm-s",
    "title": "Out Board Motor (OBM's)",
    "shortTitle": "Out Board Motor (OBM's)",
    "description": "Engineered tactical and commercial equipment for Out Board Motor (OBM's).",
    "image": "/images/capabilities/equipments/Out Board Motor.png",
    "items": [
      {
        "id": "honda-bf20",
        "type": "pdf",
        "title": "Honda BF20",
        "image": "/images/capabilities/previews/honda-bf20.png",
        "pdfUrl": "https://drive.google.com/file/d/1NlQrQ0Yh6d95YVWtK6IQ0jJnI-KcVDU7/view?usp=drive_link",
        "fileSize": "0.3 MB"
      },
      {
        "id": "honda-bf30",
        "type": "pdf",
        "title": "Honda BF30",
        "image": "/images/capabilities/previews/honda-bf30.png",
        "pdfUrl": "https://drive.google.com/file/d/1ydnETGsbfofJDQDfaEoonBwrv_9i-4IY/view?usp=drive_link",
        "fileSize": "0.1 MB"
      },
      {
        "id": "honda-bf40",
        "type": "pdf",
        "title": "Honda BF40",
        "image": "/images/capabilities/previews/honda-bf40.png",
        "pdfUrl": "https://drive.google.com/file/d/1yndUqv9UzzkG5nRWytD1k019tIAUMNB7/view?usp=drive_link",
        "fileSize": "83 KB"
      }
    ]
  },
  {
    "id": "portable-hyperbaric-chamber-hyperbaric-oxygen-therapy-hbot",
    "slug": "portable-hyperbaric-chamber-hyperbaric-oxygen-therapy-hbot",
    "title": "Portable Hyperbaric Chamber - Hyperbaric Oxygen Therapy (HBOT)",
    "shortTitle": "Portable Hyperbaric Chamber - Hyperbaric Oxygen Therapy (HBOT)",
    "description": "Engineered tactical and commercial equipment for Portable Hyperbaric Chamber - Hyperbaric Oxygen Therapy (HBOT).",
    "image": "/images/capabilities/equipments/Portable Hyperbaric Chamber.png",
    "items": [
      {
        "id": "portable-hyperbaric-chamber-sosgroup-hyperlite1-brochure",
        "type": "pdf",
        "title": "Portable Hyperbaric Chamber SOSGroup Hyperlite1 Brochure",
        "image": "/images/capabilities/previews/portable-hyperbaric-chamber-sosgroup-hyperlite1-brochure.png",
        "pdfUrl": "https://drive.google.com/file/d/1JEGijvTuo_NKvVFNHjUEMhs0KpTXTN-r/view?usp=drive_link",
        "fileSize": "2.5 MB"
      }
    ]
  },
  {
    "id": "rigid-inflatable-boat-rib-s",
    "slug": "rigid-inflatable-boat-rib-s",
    "title": "Rigid Inflatable Boat (RIB's)",
    "shortTitle": "Rigid Inflatable Boat (RIB's)",
    "description": "Engineered tactical and commercial equipment for Rigid Inflatable Boat (RIB's).",
    "image": "/images/capabilities/equipments/Rigid Inflatable Boats.jpeg",
    "items": [
      {
        "id": "shm-seafalcon-4700",
        "type": "pdf",
        "title": "SHM SEAFALCON 4700",
        "image": "/images/capabilities/previews/shm-seafalcon-4700.png",
        "pdfUrl": "https://drive.google.com/file/d/12JIrY3u-F_gCSqcOrkLrkeUyTLLrVW6P/view?usp=drive_link",
        "fileSize": "2.1 MB"
      }
    ]
  },
  {
    "id": "semi-dry-suit",
    "slug": "semi-dry-suit",
    "title": "Semi-Dry Suit",
    "shortTitle": "Semi-Dry Suit",
    "description": "Engineered tactical and commercial equipment for Semi-Dry Suit.",
    "image": "/images/capabilities/equipments/Semi-Dry Suit (1).png",
    "items": [
      {
        "id": "aqualung-semi-dry-suit",
        "type": "pdf",
        "title": "Aqualung Semi Dry Suit",
        "image": "/images/capabilities/previews/aqualung-semi-dry-suit.png",
        "pdfUrl": "https://drive.google.com/file/d/1ka80KSLWtKpZpJ7XfgSzQ7FT0kYt-aBO/view?usp=drive_link",
        "fileSize": "1.0 MB"
      },
      {
        "id": "bare-semi-dry-suit",
        "type": "pdf",
        "title": "BARE Semi Dry Suit",
        "image": "/images/capabilities/previews/bare-semi-dry-suit.png",
        "pdfUrl": "https://drive.google.com/file/d/1aBnQXybPY3vOVSsKMmEKcINrvJgnOK8P/view?usp=drive_link",
        "fileSize": "0.7 MB"
      },
      {
        "id": "mares-semi-dry-suit",
        "type": "pdf",
        "title": "Mares Semi Dry Suit",
        "image": "/images/capabilities/previews/mares-semi-dry-suit.png",
        "pdfUrl": "https://drive.google.com/file/d/13boAP4FsqzS0tnu3kMkHaFB20AI-ta_9/view?usp=drive_link",
        "fileSize": "0.6 MB"
      }
    ]
  },
  {
    "id": "sodalime-divelime-812",
    "slug": "sodalime-divelime-812",
    "title": "SodaLime - Divelime 812",
    "shortTitle": "SodaLime - Divelime 812",
    "description": "Engineered tactical and commercial equipment for SodaLime - Divelime 812.",
    "image": "/images/capabilities/equipments/SodaLime.png",
    "items": [
      {
        "id": "soda-lime-co2-absorbent-divelime-812",
        "type": "pdf",
        "title": "Soda Lime CO2 Absorbent Divelime 812",
        "image": "/images/capabilities/previews/soda-lime-co2-absorbent-divelime-812.png",
        "pdfUrl": "https://drive.google.com/file/d/1Abpge7ODUce8T8Epol7ZHuHrKrOXrwA8/view?usp=drive_link",
        "fileSize": "0.6 MB"
      }
    ]
  },
  {
    "id": "underwater-navigation-system",
    "slug": "underwater-navigation-system",
    "title": "Underwater Navigation System",
    "shortTitle": "Underwater Navigation System",
    "description": "Engineered tactical and commercial equipment for Underwater Navigation System.",
    "image": "/images/capabilities/equipments/Underwater Navigation System.png",
    "items": [
      {
        "id": "seacraft-electronic-navigation-console-enc3m-military-edition",
        "type": "pdf",
        "title": "SEACRAFT Electronic Navigation Console ENC3M Military Edition",
        "image": "/images/capabilities/previews/seacraft-electronic-navigation-console-enc3m-military-edition.png",
        "pdfUrl": "https://drive.google.com/file/d/1ts2WjAa2lajV4WKqEI9Dtsg8Lo8OlJBT/view?usp=drive_link",
        "fileSize": "7.6 MB"
      },
      {
        "id": "seacraft-gps-rf-buoy",
        "type": "pdf",
        "title": "SEACRAFT GPS RF Buoy",
        "image": "/images/capabilities/previews/seacraft-gps-rf-buoy.png",
        "pdfUrl": "https://drive.google.com/file/d/1GemrvDf8lgIKksyDtHe-kUuFAjsncAjC/view?usp=drive_link",
        "fileSize": "0.8 MB"
      },
      {
        "id": "shark-marine-navigator-brochure",
        "type": "pdf",
        "title": "Shark Marine Navigator Brochure",
        "image": "/images/capabilities/previews/shark-marine-navigator-brochure.png",
        "pdfUrl": "https://drive.google.com/file/d/12-6ImkS_DZ4ooVTWghGHtzCs8MxFhj7X/view?usp=drive_link",
        "fileSize": "4.9 MB"
      }
    ]
  },
  {
    "id": "underwater-rov-made-in-france",
    "slug": "underwater-rov-made-in-france",
    "title": "Underwater ROV - Made in France",
    "shortTitle": "Underwater ROV - Made in France",
    "description": "Engineered tactical and commercial equipment for Underwater ROV - Made in France.",
    "image": "/images/capabilities/equipments/Underwater Drone System (ROV).png",
    "items": [
      {
        "id": "seasam-rov",
        "type": "pdf",
        "title": "SEASAM ROV",
        "image": "/images/capabilities/previews/seasam-rov.png",
        "pdfUrl": "https://drive.google.com/file/d/1eS0-L5jPdFo_l3T3Dtur4PUiNkt3PCRD/view?usp=drive_link",
        "fileSize": "24.6 MB"
      }
    ]
  },
  {
    "id": "wearables",
    "slug": "wearables",
    "title": "Wearables",
    "shortTitle": "Wearables",
    "description": "Engineered tactical and commercial equipment for Wearables.",
    "image": "/images/capabilities/equipments/Wearables.png",
    "items": [
      {
        "id": "dive-boots",
        "slug": "dive-boots",
        "type": "folder",
        "title": "Dive Boots",
        "image": "/images/capabilities/wearables/Dive Boots.png",
        "items": [
          {
            "id": "aqualung-dive-boots",
            "type": "pdf",
            "title": "AquaLung Dive Boots",
            "image": "/images/capabilities/previews/aqualung-dive-boots.png",
            "pdfUrl": "https://drive.google.com/file/d/1fGNbz4ooTR9g3n_acBWaN1JA9yc4q0bq/view?usp=drive_link",
            "fileSize": "2.6 MB"
          },
          {
            "id": "bare-dive-boots",
            "type": "pdf",
            "title": "BARE Dive Boots",
            "image": "/images/capabilities/previews/bare-dive-boots.png",
            "pdfUrl": "https://drive.google.com/file/d/1XQbtRqJu-aacqe2E3PBqqF_Yhx1CyoRH/view?usp=drive_link",
            "fileSize": "0.5 MB"
          },
          {
            "id": "mares-dive-boots",
            "type": "pdf",
            "title": "Mares Dive Boots",
            "image": "/images/capabilities/previews/mares-dive-boots.png",
            "pdfUrl": "https://drive.google.com/file/d/1F79_qium7yimbshtaou7tQq29ZwKMoeX/view?usp=drive_link",
            "fileSize": "0.6 MB"
          },
          {
            "id": "tusa-dive-boots",
            "type": "pdf",
            "title": "TUSA Dive Boots",
            "image": "/images/capabilities/previews/tusa-dive-boots.png",
            "pdfUrl": "https://drive.google.com/file/d/1bRU2fBPmh3dEtKum7Rl8PY2pzI1633IM/view?usp=drive_link",
            "fileSize": "2.2 MB"
          }
        ]
      },
      {
        "id": "wetsuits",
        "slug": "wetsuits",
        "type": "folder",
        "title": "Wetsuits",
        "image": "/images/capabilities/wearables/Wetsuits.png",
        "items": [
          {
            "id": "apeks-wearables",
            "type": "pdf",
            "title": "APEKS Wearables",
            "image": "/images/capabilities/previews/apeks-wearables.png",
            "pdfUrl": "https://drive.google.com/file/d/1SL4Mwocz4cutaGjqrthB6bkzBVoZtc-y/view?usp=drive_link",
            "fileSize": "6.5 MB"
          },
          {
            "id": "aqualung-wetsuits",
            "type": "pdf",
            "title": "Aqualung Wetsuits",
            "image": "/images/capabilities/previews/aqualung-wetsuits.png",
            "pdfUrl": "https://drive.google.com/file/d/1djrtz_U0B-ew5YyH91V_0Zcw1utgw85f/view?usp=drive_link",
            "fileSize": "20.2 MB"
          },
          {
            "id": "bare-wetsuits",
            "type": "pdf",
            "title": "BARE Wetsuits",
            "image": "/images/capabilities/previews/bare-wetsuits.png",
            "pdfUrl": "https://drive.google.com/file/d/1mjX20tbz0g23K7mKTjxW-KzDm1kLKzNz/view?usp=drive_link",
            "fileSize": "9.2 MB"
          },
          {
            "id": "mares-wetsuits",
            "type": "pdf",
            "title": "Mares Wetsuits",
            "image": "/images/capabilities/previews/mares-wetsuits.png",
            "pdfUrl": "https://drive.google.com/file/d/1q0hlEO5_z9EfciZdeHXxlg6eVbC9UaBT/view?usp=drive_link",
            "fileSize": "4.4 MB"
          },
          {
            "id": "tusa-wetsuit",
            "type": "pdf",
            "title": "TUSA Wetsuit",
            "image": "/images/capabilities/previews/tusa-wetsuit.png",
            "pdfUrl": "https://drive.google.com/file/d/1Lb9t6Ucb0IEkmSMQ1EI8hOf63Ebw9-S6/view?usp=drive_link",
            "fileSize": "1.8 MB"
          }
        ]
      },
      {
        "id": "aqualung-rashguard",
        "type": "pdf",
        "title": "Aqualung Rashguard",
        "image": "/images/capabilities/previews/aqualung-rashguard.png",
        "pdfUrl": "https://drive.google.com/file/d/1WgNwqKCYipkE6T30wRAQHBu8FQs6tD_G/view?usp=drive_link",
        "fileSize": "5.2 MB"
      },
      {
        "id": "aqualung-wetsuit-accessories",
        "type": "pdf",
        "title": "Aqualung Wetsuit Accessories",
        "image": "/images/capabilities/previews/aqualung-wetsuit-accessories.png",
        "pdfUrl": "https://drive.google.com/file/d/1925wstS0lnE1lMReeeMRTYmIPYJBJ60X/view?usp=drive_link",
        "fileSize": "6.4 MB"
      },
      {
        "id": "bare-exowear",
        "type": "pdf",
        "title": "BARE Exowear",
        "image": "/images/capabilities/previews/bare-exowear.png",
        "pdfUrl": "https://drive.google.com/file/d/1qAueuVBqSdaiG6cAoNq8MJqtu05ABjrp/view?usp=drive_link",
        "fileSize": "3.3 MB"
      },
      {
        "id": "bare-wetsuit-accessories",
        "type": "pdf",
        "title": "BARE Wetsuit Accessories",
        "image": "/images/capabilities/previews/bare-wetsuit-accessories.png",
        "pdfUrl": "https://drive.google.com/file/d/16uQ18DltKQIX2wTXI3m3CD5-8nG9s0Wq/view?usp=drive_link",
        "fileSize": "6.3 MB"
      },
      {
        "id": "mares-rashguard",
        "type": "pdf",
        "title": "Mares Rashguard",
        "image": "/images/capabilities/previews/mares-rashguard.png",
        "pdfUrl": "https://drive.google.com/file/d/1d1720Vi6sLNeVLyDF_mHo6qM2NRAIqSG/view?usp=drive_link",
        "fileSize": "1.0 MB"
      },
      {
        "id": "mares-wetsuit-accessories",
        "type": "pdf",
        "title": "Mares Wetsuit Accessories",
        "image": "/images/capabilities/previews/mares-wetsuit-accessories.png",
        "pdfUrl": "https://drive.google.com/file/d/1HAU_beu8jCy6o6KjlUdagTgrfbwrHXzp/view?usp=drive_link",
        "fileSize": "1.3 MB"
      },
      {
        "id": "tusa-gloves",
        "type": "pdf",
        "title": "TUSA Gloves",
        "image": "/images/capabilities/previews/tusa-gloves.png",
        "pdfUrl": "https://drive.google.com/file/d/1Cbw6bTMB1PNRMn1fkUoaLotpYlU7Cvk_/view?usp=drive_link",
        "fileSize": "1.1 MB"
      }
    ]
  }
];
